<div class="progress-bar" *ngIf="showProgressBar">
  <div class="progress-bar__container">
    <span class="progress-bar__title">{{visibleExpection ? titleException : panelConfig?.mainTitle}}</span>
    <span class="progress-bar__step" *ngIf="featureIndex > 0 && (!currentFeatures.includes('prefferedPaymentDate') && !currentFeatures.includes('directDebitEdit'))">
      <span class="util-helper__hide-xs">Step</span>
      {{featureIndex}} of {{totalPages}}
    </span>

    <!-- Direct-debit -->
    <span class="progress-bar__step" *ngIf="(currentFeatures.includes('prefferedPaymentDate') || currentFeatures.includes('directDebitEdit'))">
      <span class="util-helper__hide-xs">Step</span>
      {{featureIndex + 1}} of {{totalPages}}
    </span>
  </div>
</div>

<section class="section">
  <div class="policy-identifier"
    [ngClass]="{'policy-identifier--hide': !showPolicyIdentifier}">
    <span [hidden]="!showPolicyIdentifier" data-recording-mask>
      {{vehicle?.vehicleMake | uppercase}} {{vehicle?.vehicleModel | uppercase}}  {{vehicle?.vehicleRegistration | uppercase}}
    </span>
  </div>

  <app-section-heading *ngIf="panelConfig.isVisible || visibleExpection"
    [mainTitle]="featureIndex > 0 ? '' : visibleExpection ? titleException : panelConfig?.mainTitle"
    [subTitle]="panelConfig.subTitle"
    [titleIcon]="titleIcon"
    [policyId]="policyId"
    [isHideSubTitleContainer]="panelConfig.isHideSubTitleContainer"
    [policyChangeDate]="policyChangeDateString"
    [isNotification]="panelConfig.isNotification"
    [isShowPolicyNumber]="panelConfig.isShowPolicyNumber">
  </app-section-heading>

  <p
    *ngIf="isPermanent && panelConfig?.priceAffectedPerm"
    [innerHTML]="panelConfig.priceAffectedPerm"
    style="max-width: 590px;">
  </p>
  <p
    *ngIf="isPermanent === false && panelConfig?.priceAffectedTemp"
    [innerHTML]="panelConfig.priceAffectedTemp"
    style="max-width: 590px;">
  </p>

  <div
    [ngClass]="{
      'section__wrapper': panelConfig.isVisible || visibleExpection,
      'section__wrapper--clean-top section__wrapper--alt':
        (panelConfig.isVisible || visibleExpection) && !panelConfig.isNotification
    }">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
    <app-loading-indicator [isLoading]="isProgressing"></app-loading-indicator>
  </div>
</section>

<!-- Recommended by Okta: use hidden iframe to avoid CORS issue when receiving Okta Id -->
<app-hidden-iframe></app-hidden-iframe>
